import React, { lazy } from 'react'

import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AircraftRateRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--aircraft-rate']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
